import { Title } from '@solidjs/meta'
import { useSearchParams } from '@solidjs/router'
import type { Component } from 'solid-js'
import GoBack from '~/components/GoBack'
import ProductForm from '~/layers/ProductForm'
import { type Path, useNavigate } from '~/router'

/**
 * Alta en el catálogo. Es la misma ficha que la de edición: lo que se rellena
 * aquí es exactamente lo que luego se edita, así que en cuanto se crea se salta
 * a su ficha para seguir con variantes y existencias.
 */
const NuevoProductoPage: Component = () => {
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()

  /** Cambiar de pestaña se refleja en la URL (?tab=...) para poder compartir y recargar la vista. */
  const handleTabChange = (tab: string) => {
    setSearchParams({ ...searchParams, tab }, { replace: true })
  }

  return (
    <>
      <Title>Nuevo en el catálogo | Florez Jaramillo</Title>

      <GoBack label="Volver al catálogo" fallbackPath="/admin/servicios" class="mb-3 text-foreground-subtle hover:text-foreground" />

      <ProductForm
        initialTab={typeof searchParams.tab === 'string' ? searchParams.tab : undefined}
        onTabChange={handleTabChange}
        onSaved={product => navigate(`/admin/servicios/${product.id}` as Path, { replace: true })}
      />
    </>
  )
}

export default NuevoProductoPage
